import { isError } from '../isError';

/**
 * Check if the given value is an Error object with a specific code
 */
export const isErrorWithCode = <T extends string>(
  error: unknown,
  code: T
): error is Error & { code: T } => {
  if (!isError(error)) return false;

  return 'code' in error && error.code === code;
};
